const mockInvoicesData = [
    {
        "id": 137,
        "invoice_number": "16112312137",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "",
        "amount": "16842.28",
        "vat_amount": "0.00",
        "total_amount": "16842.28",
        "currency": 0,
        "status": "Pending",
        "issue_date": "16.11.2023",
        "invoice_pdf": ""
    },
    {
        "id": 117,
        "invoice_number": "08022312117",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Invoice Test 6",
        "amount": "30.00",
        "vat_amount": "0.00",
        "total_amount": "30.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "08.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 115,
        "invoice_number": "08022312115",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Invoice Test 5",
        "amount": "10.00",
        "vat_amount": "0.00",
        "total_amount": "10.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "08.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 114,
        "invoice_number": "08022312114",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Invoice Test 4",
        "amount": "15.00",
        "vat_amount": "0.00",
        "total_amount": "15.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "08.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 113,
        "invoice_number": "08022312113",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Invoice Test 3",
        "amount": "24.00",
        "vat_amount": "0.00",
        "total_amount": "24.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "08.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 112,
        "invoice_number": "08022312112",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Invoice Test 2",
        "amount": "25.00",
        "vat_amount": "0.00",
        "total_amount": "25.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "08.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 111,
        "invoice_number": "08022312111",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Invoice Test 1",
        "amount": "10.00",
        "vat_amount": "5.00",
        "total_amount": "15.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "08.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 110,
        "invoice_number": "07022312110",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Test Invoice John Doe 5",
        "amount": "20.00",
        "vat_amount": "5.00",
        "total_amount": "25.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "07.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 109,
        "invoice_number": "07022312109",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Test Invoice John Doe 4",
        "amount": "32.00",
        "vat_amount": "0.00",
        "total_amount": "32.00",
        "currency": 0,
        "status": "Paid",
        "issue_date": "07.02.2023",
        "invoice_pdf": ""
    },
    {
        "id": 108,
        "invoice_number": "07022312108",
        "name": "Invoice for John Doe",
        "type": "Standard Invoice",
        "short_description": "Test Invocie for John Doe 3",
        "amount": "15.20",
        "vat_amount": "5.00",
        "total_amount": "15.20",
        "currency": 0,
        "status": "Paid",
        "issue_date": "07.02.2023",
        "invoice_pdf": ""
    }
]
export default mockInvoicesData;